// © 2025 COPYright LAHO – https://www.linkedin.com/in/laurens-holtkamp-7a686b2b/

export const getInviteGroupIdFromSearch = (search = '') => {
  const params = new URLSearchParams(search || '');
  return params.get('group') || params.get('group_id') || '';
};
